import urlParams from './urlParams';

// This is to be phased out.  Use url + urlParams(params) instead
export default function (url, params) {
  return url + urlParams(params);
}
